import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect, useSelector } from 'react-redux'
import { api, get, getBranchOwner } from "@config"
import { Form, Row, Col, Button } from 'react-bootstrap'
import CurrencyInput from "react-currency-input";
import { notification } from 'antd'

import Unit from './unit'

import Categories from './categories'

import { mapTest } from "../map.test"

import {
    setBaseProductName,
    setBaseProductBarcode,
    setBaseProductInternalCode,
    setBaseProductPrice,
    setBaseProductCost,
    setMaskCost,
    setMaskPrice
} from './actions'
import { setLoading } from '@inspinia-react/actions'

import { setNcm, setCest } from '@taxes/actions'
import { loadNcm, loadCest } from '@taxes/loadTaxes'

function SampeProductBase(props) {
    const branch = getBranchOwner().id

    function handleChangePrice(maskValue, floatValue, e) {
        props.setBaseProductPrice(floatValue)
        props.setMaskPrice(maskValue)
    }
    function handleChangeCost(maskValue, floatValue, e) {
        props.setBaseProductCost(floatValue)
        props.setMaskCost(maskValue)
    }

    function searchBarcode(barcode) {
        props.setLoading(true)
        const url = `${api.searchBarcode}?branch_owner=${branch}&barcode=${barcode}`;
        const payload = resp => {
            const { name, cost, ncm, cest } = resp.product_info;
            if (ncm) {
                setNCM(ncm)
            }
            if (cest) {
                setCEST(cest)
            }

            props.setBaseProductName(name);
            props.setBaseProductPrice(cost);
            props.setMaskPrice(cost.replace(".", ","))

            if (branch.is_fiscal) {
                if (ncm.length) loadNcm(ncm, props.setNcmData)
                if (cest.length) loadCest(cest, props.setCestData)
            }
            props.setLoading(false)
        };
        get(url, payload, err => {
            props.setLoading(false)
            notification.open({
                type: "error",
                message: "Erro ao importar o produto",
                description: "Código inválido",
                duration: 3,
                key: 777
            });
        });
    }

    function setNCM(code) {
        const url = `${api.products.ncm}?branch_owner=${branch}&code=${code}`;
        const payload = data => {
            props.setNcm(data[0])
        };
        get(url, payload)

    }
    function setCEST(code) {
        const url = `${api.products.cest}?branch_owner=${branch}&code=${code}`;
        const payload = data => {
            props.setCest(data[0])
        };
        get(url, payload)
    }

    function editBarcode(e) {
        props.setBaseProductBarcode(e.target.value)
        if (e.target.value.length === 13) {
            searchBarcode(e.target.value)
        }
    }

    return <React.Fragment>
        <Form.Group>
            <p className="mb-1 lead">Código de Barras</p>
            <Form.Group as={Row} controlId="">
                <Col xs="9" sm="8" className="">
                    <Form.Control
                        controlId="product-barcode"
                        onChange={editBarcode}
                        value={props.barcode}
                        data-input-create-product
                        disabled={props.loading}
                        id={mapTest.createProduct.inputSearchBarcode}
                    />
                </Col>
                <Col xs="3" sm="4" className="">
                    <Button
                        id={mapTest.createProduct.buttonSearchBarcode}
                        block
                        title="Importar dados a partir do código de barras"
                        disabled={props.loading || props.barcode.length < 11}
                        onClick={() => searchBarcode(props.barcode)}
                        data-create-product-button-search-barcode
                    >
                        <span className="d-md-inline d-xs-none">Importar Produto</span>
                        <i className="fa fa-search ml-1"></i>
                    </Button>
                </Col>
            </Form.Group>
        </Form.Group>
        <Form.Group>
            <p className="mb-1 lead">Nome</p>
            <Form.Control
                onChange={e => {
                    const value = e.target.value.replace(/[&$#@\\|]/g, '')
                    if (value.length > 120) {
                        props.setBaseProductName(value.substring(0, 120))
                    } else {
                        props.setBaseProductName(value)
                    }
                }}
                value={props.name}
                disabled={props.loading}
                data-create-product-input-product-name
                id={mapTest.createProduct.inputProductName}
            />
            <h5 className='mt-1 text-right' >{props.name.length}/120</h5>
        </Form.Group>
        <Form.Group>
            <p className="mb-1 lead">Código interno</p>
            <Form.Control
                onChange={e => props.setBaseProductInternalCode(e.target.value)}
                value={props.code}
                disabled={props.loading}
                data-create-product-input-code
                id={mapTest.createProduct.inputProductCode}
            />
        </Form.Group>
        <Form.Row>
            <Col>
                <p className="lead">Preço de venda</p>
                <CurrencyInput
                    className="form-control"
                    prefix="R$"
                    decimalSeparator=","
                    thousandSeparator="."
                    onChange={handleChangePrice}
                    value={props.maskPrice}
                    disabled={props.loading}
                    data-create-product-input-price
                    id={mapTest.createProduct.inputProductPrice}
                />
            </Col>
            <Col>
                <p className="lead">Preço de custos</p>
                <CurrencyInput
                    decimalSeparator=","
                    thousandSeparator="."
                    className="form-control"
                    prefix="R$"
                    onChange={handleChangeCost}
                    value={props.maskCost}
                    disabled={props.loading}
                    data-create-product-input-cost
                    id={mapTest.createProduct.inputProductCost}
                />
            </Col>
        </Form.Row>
        <Form.Row>
            <Col>
                <Unit />
                <Categories />
            </Col>
        </Form.Row>

    </React.Fragment>
}

const mapStateToProps = state => ({
    loading: state.loading,
    name: state.baseProductName,
    barcode: state.baseProductBarcode,
    code: state.baseProductInternalCode,
    price: state.baseProductPrice,
    cost: state.baseProductCost,
    maskPrice: state.maskPrice,
    maskCost: state.maskCost,

    ncmData: state.ncmData,
    cestData: state.cestData
})
const mapDispatchToProps = dispatch => bindActionCreators({
    setLoading,
    setBaseProductName,
    setBaseProductBarcode,
    setBaseProductInternalCode,
    setBaseProductPrice,
    setBaseProductCost,
    setMaskCost,
    setMaskPrice,
    setNcm,
    setCest
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SampeProductBase)



// WEBPACK FOOTER //
// ./src/components/pages/products/base/product-base.jsx